module.exports = __webpack_public_path__ + "img/COC.c576ada5.jpg";